import BaseDialog from '../Dialogs/BaseDialog';
import { AlertDialogFooter } from '../UI-CHAKRA/Dialog/AlertDialogFooter';
import { AlertDialogBody } from '../UI-CHAKRA/Dialog/AlertDialogBody';

import { Text } from '../UI-CHAKRA/Text';
import { Button } from '../UI-CHAKRA/Button';
import { useIsMobile } from '../../helpers/useIsMobile';

interface DialogAskForIncludeOrReplaceProps {
  isOpen: boolean;
  onClose(): void;
  title: string;
  text: string;
  onConfirm(value: boolean): void;
}

export function DialogAskForIncludeOrReplace(props: DialogAskForIncludeOrReplaceProps) {
  const isMobile = useIsMobile();

  return (
    <BaseDialog isOpen={props.isOpen} onClose={props.onClose} width={isMobile ? '95vw' : '360px'}>
      <Text fontSize={'18px'} fontWeight={700}>
        {props.title}
      </Text>

      <AlertDialogBody paddingLeft="0" paddingRight="0">
        <Text fontSize={'14px'} fontWeight={400} dangerouslySetInnerHTML={{ __html: props.text }} />
        <Text fontSize={'14px'} fontWeight={400}>
          Você deseja <strong>substituir</strong> ou <strong>adicionar</strong> os itens do modelo aos itens que já
          estão na sua receita?
        </Text>
      </AlertDialogBody>
      <AlertDialogFooter gap="16px" paddingLeft="0" paddingRight="0" paddingBottom="0">
        <Button
          fontSize={'15px'}
          fontWeight={'600'}
          color={'#BF0711'}
          onClick={() => props.onConfirm(true)}
          bg={'#FBEAE5'}
          w={'100%'}
          h={'40px'}
          variant={'ghost'}
        >
          Substituir
        </Button>

        <Button
          fontSize={'15px'}
          fontWeight={'600'}
          color={'#fff'}
          onClick={() => props.onConfirm(false)}
          bg={'#3484FA'}
          w={'100%'}
          h={'40px'}
          variant={'ghost'}
        >
          Adicionar
        </Button>
      </AlertDialogFooter>
    </BaseDialog>
  );
}
